import { Fragment, useCallback } from 'react'

import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import type { Message } from '@/modules/chatting/types.ts'

interface Props {
  message: Message
}

export const ChatMessageReleaseForms = ({ message }: Props) => {
  const openTagsDialog = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.SHOW_OTHER_CREATORS,
      message,
    })
  }, [message])

  return (
    <div
      className="flex cursor-pointer items-center"
      onClick={openTagsDialog}
    >
      <span className="text-primary-500 mr-1.5 text-sm shrink-0">@</span>
      <div className="flex items-center overflow-x-scroll no-scrollbar">
        <span className="text-secondary-400 dark:text-secondary-300 text-sm shrink-0">
          Tags
        </span>

        {message.releaseForms?.map(({ name, id }) => (
          <Fragment key={id}>
            <div className="bg-secondary-400 dark:bg-secondary-300 mx-2 h-1 w-1 rounded-full shrink-0" />
            <div className="text-secondary-400 dark:text-secondary-300 cursor-pointer text-sm shrink-0">
              {name}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  )
}
